import { createRouter, createWebHistory } from 'vue-router'
import DeptView from '../views/DeptView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: DeptView
  },
  {
    path: '/stocks',
    name: 'stocks',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/StockView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
